import { PARTNER_IDS } from "@chef/constants";
import { IPartnership } from ".";

export const getPartnership = (
  partnerships: IPartnership[],
  partnerId: typeof PARTNER_IDS[keyof typeof PARTNER_IDS],
) => partnerships.find((p) => p.partnerId === partnerId);
